import { ApiFrdFrdsListRequest, FRD } from "@nens/brostar/openapi-client";
import { ColumnDefinition } from "@nens/chakra/components";

import { getSearchKey } from "@/components/searchbox";
import { TableOverview } from "@/components/table-overview";
import { renderDefault } from "@/helpers/table-render-functions";
import { useQueryPagination } from "@/hooks/use-pagination";
import { useRouterTableData } from "@/hooks/use-router-table-data";
import { useFrdListQuery } from "@/queries/query-frd";

import { FilterWrapper } from "../../components/filter-wrapper";

import { FrdFilters } from "./components/frd-filters";
import { frdInformation } from "./types";

export const columnDefinitions: ColumnDefinition<FRD>[] = frdInformation.map(
  ({ key, label }, index) => ({
    title: label,
    renderFunction: (row) =>
      renderDefault(row[key], index === 0 ? `/frd/startregistratie/${row.uuid}/` : undefined),
    width: "1fr",
  })
);

export function FrdTable() {
  const {
    page,
    setPage,
    searchField: _searchField,
    searchString,
    setSearchField,
    setSearchString,
  } = useRouterTableData({ keyAddon: "FRD" });
  const searchField =
    (_searchField as keyof ApiFrdFrdsListRequest | undefined) || getSearchKey(frdInformation[0]);
  const queryParams: ApiFrdFrdsListRequest = {
    page,
    ...(searchField ? { [searchField]: searchString } : {}),
  };
  const { data: frdList, isLoading } = useFrdListQuery(queryParams);
  const paginationProps = useQueryPagination({
    queryResponse: frdList,
    page,
    setPage,
  });

  return (
    <>
      <FilterWrapper>
        <FrdFilters {...{ searchField, searchString, setSearchField, setSearchString }} />
      </FilterWrapper>
      <TableOverview
        isLoading={isLoading}
        tableData={frdList?.results || []}
        columnDefinitions={columnDefinitions}
        paginationProps={paginationProps}
      />
    </>
  );
}
